import { createSlice } from "@reduxjs/toolkit";
var initialState = {
  visible: false,
  selectedGender: ""
};
var mainNavigation = createSlice({
  name: "feedsShowSeoContent",
  initialState: initialState,
  reducers: {
    showMainNavigation: function showMainNavigation(state) {
      state.visible = true;
    },
    hideMainNavigation: function hideMainNavigation(state) {
      state.visible = false;
    },
    setSelectedGender: function setSelectedGender(state, action) {
      state.selectedGender = action.payload;
    }
  }
});
var actions = mainNavigation.actions,
    reducer = mainNavigation.reducer;
var showMainNavigation = actions.showMainNavigation,
    hideMainNavigation = actions.hideMainNavigation,
    setSelectedGender = actions.setSelectedGender;
export { showMainNavigation, hideMainNavigation, setSelectedGender };
export default reducer;